import React from "react";
import styled from "@emotion/styled";
import { Table } from "antd";
import type { TableProps } from "antd/es/table";

// Styled table specifically for batch jobs with improved row separation
export const BatchJobsTable = styled(Table)`
	& .ant-table {
		overflow-x: auto;
		font-size: 13px !important;
		color: #3e3e3e;
		height: calc(100vh - 190px);
		position: relative;
	}

	& .ant-table-body {
		tr {
			cursor: pointer !important;
			height: auto !important;
		}
		td {
			/* padding: 6px 8px !important; */
		}
	}
	

	td.ant-table-cell.video-url {
		/* white-space: nowrap; */
		span {
			/* color: #47cb38 !important; */
		}
	}

	&.ant-table-wrapper td.ant-table-column-sort {
		background: #fff;
	}

	&.ant-table-wrapper .ant-table-tbody > tr > td {
		padding: 12.9px;
		color: #282828;
		border-bottom: 1px solid #e8e8e8;
		vertical-align: top;
	}

	/* Double border for outer table rows only - not nested tables */
	&.ant-table-wrapper .ant-table-tbody > tr:not(:last-child) > td {
		border-bottom: 2px solid #000;
	}
	
	/* Ensure nested tables don't inherit the black border */
	&.ant-table-wrapper .ant-table-tbody > tr > td .ant-table-wrapper .ant-table-tbody > tr > td {
		border-bottom: 1px solid #f0f0f0;
	}

	&.ant-table-wrapper .ant-table-tbody > tr:hover > td {
		background-color: #f5f5f5;
	}

	&.ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
		background: #fafafa;
	}

	&.ant-table-wrapper .ant-table-thead > tr > th {
		border-bottom: 2px solid #d9d9d9;
		padding: 10px 12.9px;
		background-color: #fafafa;
		font-weight: 600;
	}
`;

// Styled nested table for ResultsColumn to prevent alignment issues
const StyledNestedTable = styled(Table)`
	margin-top: 0;
	height: auto !important;
	
	& .ant-table {
		background-color: transparent;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		overflow: visible;
		height: auto !important;
	}

	& .ant-table-container {
		border: none;
		height: auto !important;
	}

	& .ant-table-body {
		height: auto !important;
		max-height: none !important;
		overflow: visible !important;
	}

	& .ant-table-thead > tr > th {
		background-color: #f9f9f9;
		border-bottom: 1px solid #e8e8e8;
		padding: 6px 12px;
		font-size: 12px;
		font-weight: 600;
		color: #595959;
	}

	& .ant-table-tbody > tr > td {
		padding: 4px 12px;
		border-bottom: 1px solid #f0f0f0;
		font-size: 12px;
	}

	& .ant-table-tbody > tr:last-child > td {
		border-bottom: none;
	}

	& .ant-table-tbody > tr:hover > td {
		background-color: #fafafa;
	}
`;

// Properly typed wrapper to preserve generic types
export const BatchJobsNestedTable = <T extends Record<string, any> = any>(props: TableProps<T>) => {
	return <StyledNestedTable {...props} />;
};
